import React from "react";
import formatField from "../../utilis/formatFields";

export default function BTableCell({ isReadOnly = false, cell }) {
  // domyślna wartość z tabeli
  let value = cell?.value;

  // Jeśli to kolumna "Has Contract" – pokaż ✓ tylko gdy NIE ma "Is Closed"
  const colId = String(cell?.column?.id || "").toLowerCase();
  if (["hascontract", "has_contract", "contract"].some(k => colId.includes(k))) {
    const row = cell?.row?.original || {};
    const hasContract =
      row.hasContract ?? row.has_contract ?? row.contract ?? Boolean(value);
    const isClosed =
      row.isClosed ?? row.is_closed ?? row.closed ?? false;

    value = Boolean(hasContract) && !Boolean(isClosed);
  }

  return (
    <div
      {...cell.getCellProps()}
      className={`td border-b border-gray-200 m-0 relative p-2 h-full ${
        !isReadOnly ? "cursor-pointer" : ""
      }`}
    >
      {/* pełny tekst, a zwijanie tylko CSS-em (ellipsis zniknie po rozszerzeniu kolumny) */}
      <div className="w-full truncate">
        {formatField(value, true)}
      </div>
    </div>
  );
}
